/**
 * Cart Personalization Sync - Última Versão Garantida
 * ---------------------------------------------------------------
 * Problema que resolve:
 *   Quando o cliente compra 2+ unidades do mesmo SKU com personalizações
 *   diferentes, o checkout externo consolida as linhas do carrinho e
 *   perde as propriedades adicionais.
 *
 * Solução:
 *   Monta um resumo de TODAS as personalizações na versão mais recente
 *   do carrinho e grava como um atributo. O código escuta adições,
 *   remoções e limpezas, garantindo 100% de precisão com o estado atual.
 */

(function () {
  var ATTRIBUTE_KEY = "PERSONALIZACOES_COMPLETAS";
  var ALSO_WRITE_TO_CART_NOTE = false;
  var NOTE_MARKER = "[PERSONALIZACOES]";
  var PROPERTY_EXCLUDE_PATTERNS = [/^_/, /_gpo/i];

  var CHECKOUT_TRIGGER_SELECTORS = [
    "#update-cart",
    '[onclick*="yampiClick"]',
    '[href*="checkout"]',
    '[name="checkout"]',
    ".cart__checkout",
    "#checkout",
    "[data-checkout]",
    'button[type="submit"][form="cart"]'
  ].join(", ");

  function isPersonalizationProperty(key) {
    return !PROPERTY_EXCLUDE_PATTERNS.some(function (re) {
      return re.test(key);
    });
  }

  function buildSummary(cart) {
    var entries = [];

    (cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      var visible = Object.keys(props)
        .filter(function (k) {
          return props[k] && isPersonalizationProperty(k);
        })
        .map(function (k) {
          return props[k]; 
        });

      if (visible.length > 0) {
        entries.push(item.quantity + " Und " + item.product_title + ": " + visible.join(", "));
      }
    });

    return entries.join("  |  ");
  }

  async function syncPersonalizationAttribute() {
    try {
      // 1. Pega os dados atuais do carrinho com ANTI-CACHE (Date.now())
      // Isso obriga o navegador a buscar a versão MAIS RECENTE possível na Shopify.
      var cartRes = await fetch("/cart.js?t=" + Date.now(), { 
        cache: "no-store",
        headers: { "X-Cart-Sync": "true" } 
      });
      var cart = await cartRes.json();
      
      // 2. Constrói o novo resumo com a fotografia exata do carrinho agora
      var newSummary = buildSummary(cart);
      
      // 3. Pega o atributo que está salvo atualmente na Shopify
      var currentAttribute = (cart.attributes && cart.attributes[ATTRIBUTE_KEY]) ? cart.attributes[ATTRIBUTE_KEY] : "";

      // 4. Se o novo resumo for EXATAMENTE igual ao que já está salvo, não gasta requisição à toa.
      if (newSummary === currentAttribute) {
        console.log("[cart-personalization-sync] Carrinho inalterado, sincronização em dia.");
        return cart.attributes;
      }

      // 5. Prepara o envio. Se o carrinho ficou vazio, envia "" para deletar o registro.
      var attributesPayload = {};
      attributesPayload[ATTRIBUTE_KEY] = newSummary || ""; 

      var payload = { attributes: attributesPayload };

      if (ALSO_WRITE_TO_CART_NOTE) {
        var existingNote = cart.note || "";
        var markerIndex = existingNote.indexOf(NOTE_MARKER);
        var customerNote = (markerIndex >= 0 ? existingNote.slice(0, markerIndex) : existingNote).trim();
        payload.note = (customerNote ? customerNote + "\n\n" : "") + (newSummary ? NOTE_MARKER + "\n" + newSummary : "");
      }

      // 6. Atualiza o atributo no carrinho da Shopify
      var updateRes = await fetch("/cart/update.js", {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          "X-Cart-Sync": "true" // Evita loop no nosso próprio interceptador
        },
        body: JSON.stringify(payload)
      });

      var updatedCart = await updateRes.json();
      
      if (!newSummary) {
        console.log("%c[cart-personalization-sync] Produtos personalizados removidos. Registro apagado.", "color:#a00;font-weight:bold;");
      } else {
        console.log("%c[cart-personalization-sync] Última versão salva com sucesso:", "color:#0a0;font-weight:bold;", updatedCart.attributes);
      }
      
      return updatedCart.attributes;
    } catch (err) {
      console.error("[cart-personalization-sync] falhou ao sincronizar:", err);
      return null;
    }
  }

  window.syncPersonalizationAttribute = syncPersonalizationAttribute;

  // --- ESCUTAS E GATILHOS PARA DETECTAR QUALQUER MUDANÇA ---

  document.addEventListener("DOMContentLoaded", function () {
    syncPersonalizationAttribute();
  });

  // Intercepta botão de checkout e força a última verificação antes de redirecionar
  var isReplaying = false;
  document.addEventListener("click", function (e) {
    if (isReplaying) return; 
    var trigger = e.target.closest(CHECKOUT_TRIGGER_SELECTORS);
    if (!trigger) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    syncPersonalizationAttribute().finally(function () {
      isReplaying = true;
      try {
        if (typeof window.yampiClick === "function") {
          window.yampiClick();
        } else if (trigger.tagName === "A" && trigger.href) {
          window.location.href = trigger.href;
        } else if (trigger.form) {
          trigger.form.submit();
        } else {
          trigger.click();
        }
      } finally {
        isReplaying = false;
      }
    });
  }, true);

  // Escuta lixeiras de carrinhos AJAX (gaveta lateral, popup, etc)
  var originalFetch = window.fetch;
  window.fetch = function() {
    var isOwnRequest = arguments[1] && arguments[1].headers && arguments[1].headers['X-Cart-Sync'];
    var result = originalFetch.apply(this, arguments);
    
    if (!isOwnRequest && typeof arguments[0] === 'string' && arguments[0].match(/\/(cart|cart\/(add|update|change|clear))(\.js)?/i)) {
      result.then(function(res) {
        // Quando a Shopify confirma que o item saiu, roda nossa sincronização
        if(res.ok) setTimeout(syncPersonalizationAttribute, 800);
      }).catch(function(){});
    }
    return result;
  };

  // Escuta lixeiras de carrinhos antigos baseados em jQuery/XHR
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this.addEventListener('load', function() {
      if (typeof url === 'string' && url.match(/\/(cart|cart\/(add|update|change|clear))(\.js)?/i)) {
        setTimeout(syncPersonalizationAttribute, 800);
      }
    });
    origOpen.apply(this, arguments);
  };

  console.log("[cart-personalization-sync] script blindado carregado.");
})();